<template lang='pug'>
HelperToolbar(
  :date='date'
  v-slot='{ locationNextMonth, locationPreviousMonth }'
)
  v-toolbar(
    dark
    flat
    rounded
  )
    v-menu(
      :close-on-content-click='true'
      transition='scale-transition'
    )
      template(
        v-slot:activator='{ on, attrs }'
      )
        v-btn(
          v-bind='attrs'
          v-on='on'
          text
        )
          | #[v-icon(left) mdi-calendar] {{ date }}
      v-date-picker(
        @change='date => $emit("update:date", date_int_to_date(date_to_date_int(date)))'
        :allowed-dates='result => date_int_to_date(date_to_date_int(result)) !== date_int_to_date(from_date_int)'
        type='month'
      )
    v-btn(
      icon
      text
      :to='locationPreviousMonth'
    )
      v-icon
        | mdi-chevron-left
    v-btn(
      icon
      text
      :to='locationNextMonth'
    )
      v-icon
        | mdi-chevron-right
    v-spacer
    v-btn.hidden-sm-and-up(
      v-if='shouldShowWeighInButton'
      color='primary'
      dark
      depressed
      @click='$emit("weighIn")'
    )
      v-icon
        | mdi-plus
    v-btn.hidden-xs-only(
      v-if='shouldShowWeighInButton'
      color='primary'
      depressed
      @click='$emit("weighIn")'
    )
      | Weigh in
</template>

<script>
import {
  date_to_date_int,
  date_int_to_date,
  date_int_to_from_date_int,
  get_date_int_today,
} from '@thomasphan/helpers-fatsecret';

import { eq, pipe } from 'lodash/fp';

import HelperToolbar from './HelperToolbar.vue';

const from_date_int = function ()
{
  return pipe
  ([
    date_to_date_int,
    date_int_to_from_date_int,
  ])
  (this?.date);
};

const shouldShowWeighInButton = function ()
{
  return pipe
  ([
    get_date_int_today,
    date_int_to_from_date_int,
    eq(this?.from_date_int),
  ])
  ();
};

export default
{
  components:
  {
    HelperToolbar,
  },
  computed:
  {
    shouldShowWeighInButton,
    from_date_int,
  },
  methods:
  {
    date_int_to_date,
    date_to_date_int,
  },
  props:
  {
    date: { required: true },
  },
};
</script>